import React from "react"
import cardHOC from "./carHOC"
import modelPicture from "../../images/trainingPartners/student_2-center_720.png"

interface LearnPlusHeadingProps {
  active: boolean
}

const LearnPlusHeading: React.FC<LearnPlusHeadingProps> = (props) => {
  return (
    <h2
      style={{
        textAlign: "center",
        color: props.active ? "#00C38D" : "#092C4C",
      }}
    >
      Industry Leading
    </h2>
  )
}

const TrainingPartnersCardTemplate = cardHOC(LearnPlusHeading)

interface TrainingPartnersCardProps {
  className: string
}

const TrainingPartnersCard: React.FC<TrainingPartnersCardProps> = (props) => {
  return (
    <TrainingPartnersCardTemplate
      heading="Training Partners"
      imgSrc={modelPicture}
      content="Bringing you the best training content rated with CPD hours for ongoing professional development"
      className={props.className}
      activeColor="#00C38D"
      path="/training-partners"
      linkLabel="More about Training Partners"
    />
  )
}

export default TrainingPartnersCard
